export default "/institutions/ben.svg";